'use strict';

function LoanApplicationBankIntroduction() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._classes = {
    nextBtn: '.js--next',
    prevBtn: '.js--previous'
  };

  this.init = function () {
    this._super();
    this._$node = $(this.node);
    this._$nextBtn = this._$node.find(this._classes.nextBtn);
    this._$prevBtn = this._$node.find(this._classes.prevBtn);

    this._setupEventHandlers();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._relinkLoanApplicationStatus = this._loanApplications[0].getStatus() === 'relink';

    // Determine if it is relink
    // Users are always taken back to this introduction screen first
    // before progressing further into the bank flow.
    this.presenter.setModelProperty('money._loanApplicationRelink', this._relinkLoanApplicationStatus);

    // Analytics
    this._pushPageAnalytics();

    // Remove Page Progress loader
    this._removeProgressLoader();
  };

  this.destroy = function () {
    this._super();
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };

  this._setupEventHandlers = function () {
    var _this = this;

    this._$nextBtn.on('click', function (e) {
      e.preventDefault();
      _this._history.goToUrl(_this.paths.loans.application_flow_bank);
    });

    this._$prevBtn.on('click', function (e) {
      e.preventDefault();
      _this._history.goToUrl(_this.paths.loans.application_flow_review);
    });
  };

  this._pushPageAnalytics = function () {
    var url = window.location.pathname + (this.presenter.getModelProperty('money._loanApplicationRelink') ? '-relink' : '');

    this.analytics.forcePushEvent('virtual-page-view', {
      Page: [url]
    });
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };
}